import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../static/icons/shopping-bag.svg'


const _hoisted_1 = {
  key: 1,
  class: "add-product-to-cart__one-size"
}
const _hoisted_2 = ["onClick", "disabled"]
const _hoisted_3 = { class: "add-product-to-cart__add-button-text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "add-product-to-cart__add-button-icon"
  })
], -1)

import { computed, ref, watch } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { useCartFunctions } from '@/composables/useCartFunctions';

import Dropdown from '@/components/forms/Dropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProductToCart',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { websiteText } = useWebsiteTexts();
const { addItemToCart } = useCartFunctions();

const selectedSizeArticleNumber = ref('');

const sizes = computed(() => {
  return (props.product.sizes || []).map((s) => {
    return {
      text: s.caption,
      value: s.articleNumber,
      inStock: s.inStock,
      hilighted: s.inStock,
      articleNumber: s.articleNumber,
    };
  });
});

const selectedVariant = computed(() => {
  if (!selectedSizeArticleNumber.value) return null;

  const size = sizes.value.find(
    (s) => s.articleNumber === selectedSizeArticleNumber.value
  );
  if (!size.inStock) {
    return null;
  }
  return props.product.variants?.find(
    (s) => s.articleNumber === size.articleNumber
  );
});

async function addToCart() {
  if (!selectedVariant.value?.articleNumber) {
    return;
  }

  await addItemToCart({
    articleNumber: selectedVariant.value.articleNumber,
    quantity: 1,
  });
}

watch(
  sizes,
  () => {
    if (sizes.value.length === 1 && sizes.value[0].inStock) {
      selectedSizeArticleNumber.value = sizes.value[0].articleNumber;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_unref(sizes).length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "add-product-to-cart",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
      }, [
        (_unref(sizes).length > 1)
          ? (_openBlock(), _createBlock(Dropdown, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"])),
              options: _unref(sizes),
              expandOnTop: true,
              useOptionHighlighting: true,
              displayArrow: true,
              placeholder: _unref(websiteText)('addtocart__select_size').value,
              modelValue: selectedSizeArticleNumber.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSizeArticleNumber).value = $event)),
              class: "add-product-to-cart__size-selector"
            }, null, 8, ["options", "placeholder", "modelValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(sizes)[0].text), 1)),
        _createElementVNode("button", {
          onClick: _withModifiers(addToCart, ["prevent","stop"]),
          disabled: !_unref(selectedVariant),
          class: "add-product-to-cart__add-button primary-button"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(websiteText)('productbuy').value), 1),
          _hoisted_4
        ], 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}
}

})